<template>
  <div style="width: 100%;" class="ma-0 pa-0">
    <!-- DESKTOP -->
    <VCard class="d-none d-lg-block flex ma-0 pa-0" color="primary">
      <VDivider />

      <VCardText class="py-4 text-center text-white text-subtitle-1" style="position: relative;">
        <span
          style="cursor: pointer; position: absolute; left: 0;"
          class="ml-2"
          @click="openPrivacy"
        >
          {{ $t('privacy_label') }}
        </span>

        {{ new Date().getFullYear() }} — 
        <strong>
          {{ $t('developed_by') }}
          <a href="https://www.dreamdealtech.pt/" class="text-white">Dreamdeal Technologies</a>
        </strong>

        <div style="position: absolute; right: 0; top: 0;" class="d-none d-lg-block mt-4">
          <span class="mr-2" style="cursor: pointer;" @click="openStatus">Reportlake Status</span>
          <span class="mr-2">|</span>
          <span class="mr-4" style="cursor: pointer;" @click="openTerms">{{ $t('termos_condicoes') }}</span>
          <VIcon class="mr-2" @click="goTo({ url: 'https://www.linkedin.com/showcase/report-lake' })">mdi-linkedin</VIcon>
          <VIcon class="mr-2" @click="goTo({ url: 'https://www.facebook.com/dreamdealtech' })">mdi-facebook</VIcon>
        </div>

        <div class="d-md-none mt-4">
          <VIcon class="mr-2" @click="goTo({ url: 'https://www.linkedin.com/showcase/report-lake' })">mdi-linkedin</VIcon>
          <VIcon class="mr-2" @click="goTo({ url: 'https://www.facebook.com/dreamdealtech' })">mdi-facebook</VIcon>
        </div>
      </VCardText>
    </VCard>

    <!-- MOBILE -->
    <VCard class="d-md-none ma-0 pa-0" color="primary">
      <VCardText class="py-1 text-center text-white text-caption">
        <VRow>
          <VCol cols="12" align="center">
            {{ new Date().getFullYear() }} —
            <strong>
              {{ $t('developed_by') }}
              <a href="https://www.dreamdealtech.pt/" class="text-white">Dreamdeal Technologies</a>
            </strong>
          </VCol>
        </VRow>

        <div class="d-md-none">
          <VRow>
            <VCol cols="12">
              <span class="mr-2" style="cursor: pointer;" @click="openTerms">{{ $t('termos_condicoes') }}</span>
              <span class="mr-2">|</span>
              <span class="mr-2" style="cursor: pointer;" @click="openPrivacy">{{ $t('privacy_label') }}</span>
              <span class="mr-2">|</span>
              <span class="mr-2" style="cursor: pointer;" @click="openStatus">Status</span>
            </VCol>

            <VCol class="mt-n4" cols="12" align="center">
              <VIcon class="mr-2" @click="goTo({ url: 'https://www.linkedin.com/showcase/report-lake' })">mdi-linkedin</VIcon>
              <VIcon class="mr-2" @click="goTo({ url: 'https://www.facebook.com/dreamdealtech' })">mdi-facebook</VIcon>
            </VCol>
          </VRow>
        </div>
      </VCardText>
    </VCard>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    icons: ['mdi-facebook', 'mdi-twitter', 'mdi-linkedin', 'mdi-instagram'],
    social_networks: [
      { icon: 'mdi-linkedin', url: 'https://www.linkedin.com/showcase/report-lake' },
      { icon: 'mdi-facebook', url: 'https://www.facebook.com/dreamdealtech' }
    ]
  }),
  methods: {
    openStatus() {
      window.open('https://reportlake.statuspage.io/')
    },
    goTo(social) {
      window.open(social.url)
    },
    openPrivacy() {
      window.open('/' + this.$i18n.locale + '/privacy', '_blank')
    },
    openTerms() {
      window.open('/' + this.$i18n.locale + '/terms-and-conditions', '_blank')
    }
  }
}
</script>
